"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notification = exports.root = void 0;

var _emotion = require("emotion");

var _selectionType = _interopRequireDefault(require("./selectionType"));

var root = function root(theme, rounded, _ref, disabled) {
  var selected = _ref.selected,
      type = _ref.type;
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", theme.color.dark.white, ";fill:", theme.color.dark.white, ";border-radius:", rounded ? '30px' : '2px', ";font-weight:500;letter-spacing:0.86px;font-size:12px;display:inline-flex;align-items:center;border:none;outline:none;position:relative;transition:all 0.3s;cursor:", disabled ? 'not-allowed' : 'pointer', ";text-transform:", type === _selectionType.default.Normal ? '' : 'uppercase', ";background-color:", selected ? type === _selectionType.default.Normal ? theme.color.dark.white0_12 : theme.color.dark.sapphire : 'transparent', ";padding:", rounded ? '12px' : '16px 12px', ";&:hover{background-color:", theme.color.dark.sapphireHover, ";}&:focus,&:active{background-color:", theme.color.dark.sapphireFocus, ";}")
  );
};

exports.root = root;

var notification = function notification(theme, count) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;top:2px;right:20px;width:0px;&::after{content:'", count, "';display:flex;align-items:center;height:16px;width:fit-content;border-radius:10px;padding:0px 4px;color:", theme.color.dark.white, ";background-color:", theme.color.dark.sapphire, ";font-size:12px;font-weight:bold;line-height:normal;}")
  );
};

exports.notification = notification;